/**
 * LeagueTableUserEvents
 * Registry of events for LeagueTable components
 */
export enum LeagueTableUserEvents {
    ChangeTab = "LeagueTable - Change Tab",
    leagueTableNetworkLinkClick = "LeagueTable - Network Link Click",
    leagueTableProtocolLinkClick = "LeagueTable - Protocol Link Click",
    leagueTableAssetClassLinkClick = "LeagueTable - Asset Class Link Click",
    leagueTableAssetLinkClick = "LeagueTable - Asset Link Click",
    leagueTableManagerLinkClick = "LeagueTable - Manager Link Click",
    LoginCtaOpen = "LeagueTable - Login CTA Open",
    LoginCtaClose = "LeagueTable - Login CTA Close",
    LoginCtaConfirmed = "LeagueTable - Login CTA Confirmed",
    ChangeDistribution = "LeagueTable - Change Distribution",
}
